export const achievementCelebrationTranslations = {
  en: {
    yourCollection: 'Your collection',
    earned_one: '{{count}} earned',
    earned_other: '{{count}} earned',
    toGo_one: '{{count}} to go',
    toGo_other: '{{count}} to go',
    allEarned: 'All {{count}} earned',
    earnedAndLeft: '{{earned}} · {{left}}',
    since: 'since {{date}}',
    shareTitle_one: '{{name}} has earned {{count}}',
    shareTitle_other: '{{name}} has earned {{count}}',
    keptInBelore: 'Kept in Belore',
    board: '{{earned}} of {{total}} achievements earned',
    motivation: {
      start: 'Every library starts with one shelf.',
      rhythm: 'Your reading, finding its rhythm.',
      shape: 'A reading life, taking shape.',
      oneLeft: 'One more, and the collection is whole.',
      complete: 'Your whole collection, earned by reading.',
    },
  },
  sk: {
    yourCollection: 'Tvoja zbierka',
    earned_one: '{{count}} získaná',
    earned_few: '{{count}} získané',
    earned_many: '{{count}} získaných',
    earned_other: '{{count}} získaných',
    toGo_one: 'zostáva {{count}}',
    toGo_few: 'zostávajú {{count}}',
    toGo_many: 'zostáva {{count}}',
    toGo_other: 'zostáva {{count}}',
    allEarned: 'Všetkých {{count}} získaných',
    earnedAndLeft: '{{earned}} · {{left}}',
    since: 'od {{date}}',
    shareTitle_one: '{{name}} má získanú {{count}}',
    shareTitle_few: '{{name}} má získané {{count}}',
    shareTitle_many: '{{name}} má získaných {{count}}',
    shareTitle_other: '{{name}} má získaných {{count}}',
    keptInBelore: 'Uchované v Belore',
    board: 'Získané výzvy: {{earned}} z {{total}}',
    motivation: {
      start: 'Každá knižnica začína jednou poličkou.',
      rhythm: 'Tvoje čítanie si nachádza rytmus.',
      shape: 'Čitateľský život naberá tvar.',
      oneLeft: 'Ešte jedna a zbierka je kompletná.',
      complete: 'Celá zbierka, získaná čítaním.',
    },
  },
  cs: {
    yourCollection: 'Tvoje sbírka',
    earned_one: '{{count}} získaná',
    earned_few: '{{count}} získané',
    earned_many: '{{count}} získaných',
    earned_other: '{{count}} získaných',
    toGo_one: 'zbývá {{count}}',
    toGo_few: 'zbývají {{count}}',
    toGo_many: 'zbývá {{count}}',
    toGo_other: 'zbývá {{count}}',
    allEarned: 'Všech {{count}} získáno',
    earnedAndLeft: '{{earned}} · {{left}}',
    since: 'od {{date}}',
    shareTitle_one: '{{name}} má získanou {{count}}',
    shareTitle_few: '{{name}} má získané {{count}}',
    shareTitle_many: '{{name}} má získaných {{count}}',
    shareTitle_other: '{{name}} má získaných {{count}}',
    keptInBelore: 'Uchováno v Belore',
    board: 'Získané výzvy: {{earned}} z {{total}}',
    motivation: {
      start: 'Každá knihovna začíná jednou poličkou.',
      rhythm: 'Tvoje čtení si nachází rytmus.',
      shape: 'Čtenářský život nabírá tvar.',
      oneLeft: 'Ještě jedna a sbírka je kompletní.',
      complete: 'Celá sbírka, získaná čtením.',
    },
  },
};
